import cn from './cn'
import de from './de'
import en from './en'
import es from './es'
import fr from './fr'
import it from './it'
import pl from './pl'
import pt from './pt'
export default {
  cn,
  en,
  fr,
  es,
  pl,
  it,
  de,
  pt,
}
